import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ConfirmDeleteDialog = ({
  open,
  setOpen,
  entityName,
  onConfirm,
  loading,
  error,
  confirmTestId,
  cancelTestId,
}) => (
  <Dialog
    open={open}
    onKeyDown={(e) => {
      if (e.key === "Escape") setOpen(false);
    }}
  >
    <DialogTitle sx={{ color: "error.main" }}>Delete {entityName}?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete <strong>"{entityName}"</strong>? This
        action cannot be undone.
      </DialogContentText>
    </DialogContent>
    {error && (
      <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
        {error.message}
      </Alert>
    )}
    <DialogActions>
      <Button data-testid={cancelTestId} onClick={() => setOpen(false)}>
        Cancel
      </Button>
      <Button
        data-testid={confirmTestId}
        onClick={() => onConfirm()}
        disabled={loading}
        color="error"
        variant="contained"
      >
        {loading ? (
          <CircularProgress size={20} sx={{ color: "inherit" }} />
        ) : (
          "Delete"
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
